import { Choice } from './choice.model';

export interface ChoiceReference {
  pronunciation?: string[];
  // Add other properties if needed
}
/**
 * Represents a question object that extends the Choice class.
 */
export class Question extends Choice {
  /**
   * The top text of the question.
   */
  topText!: string

  /**
   * The bottom text of the question.
   */
  bottomText!: string

  /**
   * The end text of the question.
   */
  endText!: string

  /**
   * The translation of the question.
   */
  translation!: string

  /**
   * Indicates whether the translation should be shown.
   */
  shouldShowTranslation!: boolean

  /**
   * Additional reference data for the question.
   */
  reference!: ChoiceReference

  /**
   * Additional reference data for the question.
   */
  postAnswerAudios?: string[]
  /**
   * Constructs a new Question instance.
   * @param {Partial<Question>} options - An object containing optional properties for the question.
   */
  constructor(options: Partial<Question>) {
    super(options);

    // Initialize optional properties if provided
    if (options) {
      this.topText = options.topText ?? ''
      this.bottomText = options.bottomText ?? ''
      this.endText = options.endText ?? ''
      this.translation = options.translation ?? ''
      this.shouldShowTranslation = options.shouldShowTranslation || false
      this.postAnswerAudios = options.postAnswerAudios ?? []
      this.reference = options.reference ?? { pronunciation: [] }
    }
  }

  /**
   * Determines if the question is valid.
   * Overrides the isValid method of the Choice class.
   * @returns {boolean} True if the question is valid; otherwise, false.
   */
  override get isValid(): boolean {
    return super.isValid || this.audio?.name === '[All]'
  }
}
